import { createReducer } from '@reduxjs/toolkit'
import { preloadedRootState } from '../../rootState'
import { setAdmin, setAdminReducer } from './setAdminReducer'

const userReducers = createReducer(preloadedRootState.admin, builder => {
  builder.addCase(setAdmin.type, setAdminReducer)
})

export default userReducers
